import {
  APIGetRequest,
  APIPostRequest,
  APIPutRequest,
} from '@ancon/wildcat-types'

import Request from '../../client/Request'
import { APIType } from '../../types'
import endpoints from '../endpoints'
import {
  GuestDetailsRequest,
  GuestHoldRequest,
  GuestReservationHistoryResponse,
  GuestReservationResponse,
} from '../../../features/booking/types'

type OutletParams = {
  tenantId: string
  outletId: string
}

type ReservationParams = OutletParams & {
  reservationId: string
}

type ReservationsAPI = {
  get: {
    /** The signed-in guest's bookings, found from the Firebase token */
    list: APIGetRequest<
      GuestReservationHistoryResponse,
      {
        'Extent.Outlets'?: boolean
        /** Outlet-local business date, inclusive */
        from?: string
        /** Outlet-local business date, exclusive */
        until?: string
        offset?: number
        limit?: number
      }
    >
    details: APIGetRequest<GuestReservationResponse, ReservationParams>
  }
  post: {
    hold: APIPostRequest<
      GuestReservationResponse,
      GuestHoldRequest,
      OutletParams
    >
    confirm: APIPostRequest<
      GuestReservationResponse,
      { idempotencyKey: string },
      ReservationParams
    >
  }
  put: {
    guestDetails: APIPutRequest<
      GuestReservationResponse,
      GuestDetailsRequest,
      ReservationParams
    >
  }
}

const reservationEndpoints =
  endpoints.reservation.tenants.byId.outlets.byId.reservations

const reservations: ReservationsAPI = {
  get: {
    list: new Request(endpoints.reservation.reservations.list, {
      apiType: APIType.Reservation,
    }).get,
    details: new Request(reservationEndpoints.byId.details, {
      apiType: APIType.Reservation,
    }).get,
  },
  post: {
    hold: new Request(reservationEndpoints.holds.list, {
      apiType: APIType.Reservation,
    }).post,
    confirm: new Request(reservationEndpoints.byId.confirm.list, {
      apiType: APIType.Reservation,
    }).post,
  },
  put: {
    guestDetails: new Request(reservationEndpoints.byId.guestDetails.list, {
      apiType: APIType.Reservation,
    }).put,
  },
}

export default reservations
